import { Mqtt_Topics_sessionsChanges, Mqtt_Topics_reportChanges } from "../Optiscan.Models/Api/Api.js";
import { ofArray } from "../fable_modules/fable-library.3.7.12/List.js";
import { Msg } from "./DashboardTypes.js";

export function subscribe(uid) {
    return [ofArray([Mqtt_Topics_reportChanges(uid), Mqtt_Topics_sessionsChanges(uid)]), (arg0) => (new Msg(2, arg0))];
}

